module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-257.eae6e9b.woff2";